export enum CupLidType {
  Standard = 'Standard',
  StandardEcoCompostable = 'StandardEcoCompostable',
  Reserve = 'Reserve',
  ReserveEcoCompostable = 'ReserveEcoCompostable',
}

/** The backend enum ordinals, which existing rows may still hold. */
export const cupLidTypeOrdinals: Record<string, CupLidType> = {
  '0': CupLidType.Standard,
  '1': CupLidType.StandardEcoCompostable,
  '2': CupLidType.Reserve,
  '3': CupLidType.ReserveEcoCompostable,
};
